import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const PieChart20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 0.25C9.58579 0.25 9.25 0.585786 9.25 1V10C9.25 10.5247 9.80038 10.8933 10.2856 10.6935L18.7856 7.19351C19.1617 7.03861 19.3458 6.61205 19.2005 6.23207C17.8179 2.61709 14.0026 0.25 10 0.25ZM10.75 8.88008V1.78214C13.6527 2.031 16.2757 3.70503 17.5016 6.10001L10.75 8.88008Z'
      fill='currentColor'
    />
    <path
      d='M3.25 10C3.25 7.06218 5.12724 4.56088 7.74993 3.63389L7.25007 2.21964C4.0468 3.35183 1.75 6.40673 1.75 10C1.75 14.5563 5.44365 18.25 10 18.25C14.5563 18.25 18.25 14.5563 18.25 10H16.75C16.75 13.7279 13.7279 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10Z'
      fill='currentColor'
    />
  </Svg>
);

PieChart20.displayName = 'PieChart20';
export default PieChart20;
